import { render } from "./ProfileIndividual.vue?vue&type=template&id=b9964ad0"
import script from "./ProfileIndividual.vue?vue&type=script&lang=js"
export * from "./ProfileIndividual.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__